import React, { useEffect, useState } from "react";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import { images } from "../../../config/images";
import {Grid,FormControlLabel,Radio,RadioGroup,FormControl,OutlinedInput,InputAdornment,} from "@mui/material";
import { Button } from "../../../components/Button/button";
import { useNavigate, Link } from "react-router-dom";
import ImageUpload from "../../../components/ImageUpload/ImageUpload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import { signup } from "../../../config/services";
import translations from "../../../config/language";
import { auth, signInWithPhoneNumber, setUpRecaptcha,} from "../../../config/firebase";
import { notifyError, notifySuccess } from "../../../config/ToastMessage";

const SignUpForm = ({
  setMobileNo,
  setEmail,
  onNextClick,
  formValues,
  setFormValues,
  mobileVerify,
}) => {
  const navigate = useNavigate();

  const [formvalues, setFormvalue] = useState({
    profileImage: null,
    role: "",
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    mobileNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    ...formValues, // Load previous values
  });

  const [loading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    setFormvalue((prev) => ({ ...prev, ...formValues }));
  }, [formValues]);

  const handleChange = (e) => {
    setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
    setFormValues({ ...formvalues, [e.target.name]: e.target.value }); //  Save values in SignUp.js
  };

  const handleRoleChange = (e) => {
    setFormvalue({ ...formvalues, role: e.target.value });
    setFormValues({ ...formvalues, role: e.target.value }); //  Save values in SignUp.js
  };

  const handleSubmit = async () => {
    if (!formvalues.profileImage) {
      notifyError("Please upload Profile Photo.");
      return true;
    }
    if (!formvalues.firstName) {
      notifyError("Please enter First Name.");
      return true;
    }

    if (!formvalues.middleName) {
      notifyError("Please enter Middle Name.");
      return true;
    }

    if (!formvalues.lastName) {
      notifyError("Please enter Last Name.");
      return true;
    }

    if (!formvalues.gender) {
      notifyError("Please select Gender.");
      return true;
    }

    if (!formvalues.mobileNumber) {
      notifyError("Please enter Mobile Number.");
      return true;
    }

    const mobileRegex = /^[0-9]\d{9}$/;
    if (!mobileRegex.test(formvalues.mobileNumber)) {
      notifyError("Please enter a valid Mobile Number.");
      return true;
    }
    if (!mobileVerify) {
      notifyError("Please verify your mobile number before proceeding.");
      return true;
    }
    if (!formvalues.email) {
      notifyError("Please enter email id.");
      return true;
    }

    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(formvalues.email)) {
      notifyError("Please enter valid email.");
      return true;
    }

    // ✅ Password validation
    if (!formvalues.password) {
      notifyError("Please enter a password.");
      return true;
    }

    if (formvalues.password.length < 8) {
      notifyError("Password must be at least 8 characters long.");
      return true;
    }

    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
    if (!passwordRegex.test(formvalues.password)) {
      notifyError(
        "Password must contain at least one uppercase letter, one number, and one special character."
      );
      return true;
    }

    if (!formvalues.confirmPassword) {
      notifyError("Please confirm your password.");
      return true;
    }

    if (formvalues.password !== formvalues.confirmPassword) {
      notifyError("Passwords do not match.");
      return true;
    }

    const formData = new FormData(); // ✅ Create FormData object

    formData.append("profile_photo", formvalues.profileImage); // ✅ Attach file
    formData.append("first_name", formvalues.firstName);
    formData.append("middle_name", formvalues.middleName);
    formData.append("last_name", formvalues.lastName);
    formData.append("gender", formvalues.gender === "male" ? 0 : 1);
    formData.append("role", 3); // Admin user only 
    formData.append("mobile_number", `91${formvalues.mobileNumber}`);
    formData.append("email", formvalues.email);
    formData.append("password", formvalues.password);
    formData.append("is_mobile_verify", mobileVerify ? true : false);

    try {
      setIsLoading(true);
      const resp = await signup(formData);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setIsLoading(false);
        navigate("/");
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setIsLoading(false);
    }
  };

  const handleImageChange = (file) => {
    setFormvalue({ ...formvalues, profileImage: file });
    setFormValues({ ...formvalues, profileImage: file }); //  Save values in SignUp.js
  };

  const sendOtp = async (phoneNumber) => {
    if (!phoneNumber) {
      toast.error("Please enter a mobile number.");
      return;
    }
    const formattedPhoneNumber = `+91 ${phoneNumber}`;
    try {
      // ✅ Ensure reCAPTCHA is initialized
      setUpRecaptcha();
      // ✅ Send OTP
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        formattedPhoneNumber,
        window.recaptchaVerifier
      );
      window.confirmationResult = confirmationResult;
      notifySuccess("OTP Sent Successfully!");
      onNextClick("verifyOtp"); // ✅ Navigate to OTP Verification Screen
    } catch (error) {
      console.log("error", error);
      notifyError(error.message);
    }
  };

  const handleVerifyMobileNumber = () => {
    if (formvalues.mobileNumber.trim() !== "") {
      // Ensure mobile number is entered
      // Only send otp when mobile number is present

      sendOtp(formvalues.mobileNumber);
    } else {
      notifyError("Please enter mobile number.");
    }
  };
  const handleVerifyEmail = () => {
    if (formvalues.mobileNumber.trim() !== "") {
      // Ensure mobile number is entered
      setEmail(formvalues.email);
      onNextClick("verifyEmail"); // Only navigate when mobile number is present
    } else {
      notifyError("Please enter a Email");
    }
  };

  const handleTogglePasswordVisibility = (name) => {
    if (name === "password") {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    } else if (name === "confirmPassword") {
      setShowConfirmPassword(
        (prevShowConfirmPassword) => !prevShowConfirmPassword
      );
    }
  };

  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <>
      <div></div>
      <Grid container className="main-container">
        <SliderAuth />
        <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
          <div className="logo-div">
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
              className="page-back-btn"
            >
              {" "}
              {/* navigate to back screen */}
              <ArrowBackIcon className="back-arrow-icon" />
            </Link>
            <div className="">
              <img
                src={images.signupLogo}
                alt="Sign Up"
                className="signIn-logo"
              />
            </div>
          </div>
          <h3 className="text-center singIn-title">
            {translations[language].signUp}
          </h3>

          {/* Sing up Form  */}

          <div className="signUp-form">
            <div className="signup-image-upload">
              <ImageUpload
                onImageChange={handleImageChange}
                profileImage={formValues.profileImage}
              />
            </div>

        {/* <p className="singIn-option-p">
              {translations[language].selectUser}
            </p> */}
                 {/*<RadioGroup
              row
              value={formvalues.role}
              onChange={handleRoleChange}
              className="login-type"
              style={{ paddingBottom: "10px" }}
            >
              <div className="singIn-option-div">
                <FormControlLabel
                  value="admin"
                  control={<Radio />}
                  label={translations[language].admin}
                />
              </div>
              <div className="singIn-option-div">
                <FormControlLabel
                  value="superadmin"
                  control={<Radio />}
                  label={translations[language].superAdmin}
                />
              </div>
            </RadioGroup> */}

            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formvalues.firstName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z]*$/.test(value)) {
                    setFormValues({ ...formValues, firstName: value });
                  }
                }}
                name="firstName"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileNumberIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].firstName}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formvalues.middleName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z]*$/.test(value)) {
                    setFormValues({ ...formValues, middleName: value });
                  }
                }}
                name="middleName"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileNumberIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].middleName}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formvalues.lastName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z]*$/.test(value)) {
                    setFormValues({ ...formValues, lastName: value });
                  }
                }}
                name="lastName"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileNumberIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].lastName}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }} style={{ boxShadow: "unset" }}>
              <RadioGroup
                row
                className="login-type"
                style={{ background: "#f7f7f7" }}
                // style={{ paddingBottom: "10px" }}
                name="gender"
                value={formvalues.gender}
                onChange={handleChange}
              >
                <div className="singIn-option-div">
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label={translations[language].male}
                  />
                </div>
                <div className="singIn-option-div">
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label={translations[language].female}
                  />
                </div>
              </RadioGroup>
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formvalues.mobileNumber}
                onChange={handleChange}
                name="mobileNumber"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 10,
                  pattern: "[0-9]*",
                  inputMode: "numeric",
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <span
                      style={{ color: "#31A05F", cursor: "pointer" }}
                      onClick={() => handleVerifyMobileNumber()}
                    >
                      {translations[language].verify}
                    </span>
                  </InputAdornment>
                }
                placeholder={`${translations[language].mobileNumber}*`}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formvalues.email}
                onChange={handleChange}
                name="email"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.emailIcon}
                      alt="email-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <span
                      style={{ color: "#31A05F", cursor: "pointer" }}
                      onClick={() => handleVerifyEmail()}
                    >
                      {translations[language].verify}
                    </span>
                  </InputAdornment>
                }
                placeholder={`${translations[language].email}*`}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
              <OutlinedInput
                id="outlined-adornment-password"
                type={showPassword ? "text" : "password"}
                value={formvalues.password}
                onChange={handleChange}
                name="password"
                startAdornment={
                  <InputAdornment position="start">
                    <img src={images.viewPassword} className="input-logo"></img>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.viewIcon}
                      onClick={() => handleTogglePasswordVisibility("password")}
                      className="input-logo"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </InputAdornment>
                }
                placeholder={translations[language].enterPassword}
              />
            </FormControl>
            <FormControl
              fullWidth
              sx={{ m: 1 }}
              variant="outlined"
              style={{ paddingBottom: "15px" }}
            >
              <OutlinedInput
                id="outlined-adornment-password"
                type={showconfirmPassword ? "text" : "password"}
                value={formvalues.confirmPassword}
                onChange={handleChange}
                name="confirmPassword"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <img src={images.viewPassword} className="input-logo"></img>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.viewIcon}
                      onClick={() =>
                        handleTogglePasswordVisibility("confirmPassword")
                      }
                      className="input-logo"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </InputAdornment>
                }
                placeholder={translations[language].rePassword}
              />
            </FormControl>

            <div id="recaptcha-container"></div>
            <div style={{ paddingtop: "10px" }}>
              <Button
                title={translations[language].signUp}
                classname={"custom-button"}
                onClick={handleSubmit}
                loading={loading}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
export default SignUpForm;
